import {
    Button,
    Col,
    Input,
    Form,
    Row,
    Switch,
    DatePicker,
    Space,
    type DatePickerProps,
    Select,
    Tooltip,
} from 'antd'
import commonStyles from '../../../../../../Utils/Common.less'
import React, { useEffect, useState } from 'react'
import { SaveOutlined } from '@ant-design/icons'
import dayjs from 'dayjs'
import { connect, useDispatch } from 'react-redux'
import {
    GetCountryList,
    GetInduvidualList,
    GetPartneshipContactInformation,
} from '../../../../../../Services/Common'
import {
    type PartnerTogilleAddress,
    type PartnersDataFormInterface,
    type PartnersDataInterface,
    type IndividualData,
} from '../../../../../../Types/Client/RegisteredClients/Partnership'
import {
    GetInduvidualInfo,
    GetPartnerAddress,
    SavePartner,
    getClientCompanyDetails,
} from '../../../../../../Services/Parnership'
import moment from 'moment'
import { validateName } from '../../../../../../Utils/Common'
import { validateDate } from '../../../../../../Utils/ValidateDate'
import PostCodeInput from '../../../../../../Components/PostCodeInput'
import { type ListFrontEndInterface } from '../../../../../../Types/CommonType'
import InputFieldNINumber from '../../../../../../Components/InputNINO'

// import ActivePremission from '../../../../../../Utils/premissins'
// import { PermissionType } from '../../../../../../Types/Enum/PermissionType'
const Partners = (props: PartnersDataFormInterface): React.ReactElement => {
    const {
        countryList,
        partnershipId,
        InduvidualMemberList,
        resetdata,
        setResetData,
        handleSave,
        activeTab,
    } = props

    const [form] = Form.useForm()
    const dispatch = useDispatch()
    const [selectedDate, setSelectedDate] = useState<string>('')
    const [addressDatas, setAddressData] =
        useState<PartnerTogilleAddress | null>(null)
    const [switchStates, setSwitchStates] = useState<{
        1: boolean
        2: boolean
        3: boolean
    }>({
        1: false,
        2: false,
        3: false,
    })
    const [induvidualInfo, setInduvidualInfo] = useState<IndividualData | null>(
        null
    )
    const [buttonLoading, setButtonLoading] = useState(false)
    const [address, setAddress] = useState({
        line_1: '',
        line_2: '',
        line_3: '',
        post_town: '',
        postcode: '',
        country: '',
    })
    useEffect(() => {
        const countryData = countryList?.find(
            (data: ListFrontEndInterface) =>
                data.label === address?.country?.toUpperCase()
        )
        if (address.line_1 !== '') {
            const AddressData = {
                partnerAddressOne: address.line_1,
                partnerAddressTwo: address.line_2,
                partnerTown: address.post_town,
                partnerCountry: countryData?.label ?? '',
                partnerPostCode: address.postcode,
            }

            form.setFieldsValue(AddressData)
        }
    }, [address])
    useEffect(() => {
        const newSwitchStates = {
            1: false,
            2: false,
            3: false,
        }
        setSwitchStates(newSwitchStates)
        form.resetFields()
    }, [activeTab])
    useEffect(() => {
        if (resetdata === 'true') {
            form.resetFields()
        }
        setResetData('false')
    }, [resetdata])

    useEffect(() => {
        GetCountryList(dispatch)
        GetInduvidualList(dispatch)
    }, [dispatch])

    const onChange = (dateOfBirth: DatePickerProps['value']): void => {
        if (dateOfBirth != null) {
            const isoDate = dateOfBirth.toISOString()
            setSelectedDate(isoDate)
            form.setFieldValue('dateOfBirth', isoDate)
            void form.validateFields(['dateOfBirth'])
        }
    }

    useEffect(() => {
        form.setFieldValue('dateOfBirth', selectedDate)
    }, [selectedDate])

    const handleSwitchChange = (switchId: 1 | 2 | 3): void => {
        const newSwitchStates = {
            1: false,
            2: false,
            3: false,
        }
        if (!switchStates[switchId]) {
            newSwitchStates[switchId] = true
            void GetPartnerAddress(
                dispatch,
                partnershipId,
                switchId,
                (addressData: PartnerTogilleAddress) => {
                    setAddressData(addressData)
                }
            )
        } else {
            const newFieldValues = {
                partnerAddressOne: '',
                partnerAddressTwo: '',
                partnerTown: '',
                partnerCountry: '',
                partnerPostCode: '',
            }

            form.setFieldsValue(newFieldValues)
        }
        setSwitchStates(newSwitchStates)
    }

    useEffect(() => {
        if (addressDatas !== null && typeof addressDatas === 'object') {
            const newFieldValues = {
                partnerAddressOne: addressDatas?.addressLineOne,
                partnerAddressTwo: addressDatas?.addressLineTwo,
                partnerTown: addressDatas?.town,
                partnerCountry: addressDatas?.country,
                partnerPostCode: addressDatas?.postCode,
            }

            form.setFieldsValue(newFieldValues)
        }
    }, [addressDatas])

    const handleIndividualChange = (value: number): void => {
        if (value !== undefined && value !== null && value !== 0) {
            void GetInduvidualInfo(
                dispatch,
                value,
                (induviduaInformation: IndividualData) => {
                    setInduvidualInfo(induviduaInformation)
                }
            )
        } else {
            form.resetFields()
            setSelectedDate('')
        }
    }
    useEffect(() => {
        if (induvidualInfo !== null && typeof induvidualInfo === 'object') {
            const newValues = {
                individualId: induvidualInfo?.individualId,
                title: induvidualInfo?.title,
                firstName: induvidualInfo?.firstName,
                middleName: induvidualInfo?.middleName,
                surName: induvidualInfo?.surName,
                dateOfBirth: moment(induvidualInfo?.dateOfBirth).format(
                    'DD/MM/YYYY'
                ),
                partnerAddressOne: induvidualInfo?.addressOne,
                partnerAddressTwo: induvidualInfo?.addressTwo,
                partnerTown: induvidualInfo?.town,
                partnerCountry: induvidualInfo?.country,
                partnerPostCode: induvidualInfo?.postCode,
                mobileNumber: induvidualInfo?.mobileNumber,
                homeNumber: induvidualInfo?.homeNumber,
                workNumber: induvidualInfo?.workNumber,
                emailAddress: induvidualInfo?.emailAddress,
                alternativeEmailAddress:
                    induvidualInfo?.alternativeEmailAddress,
                individualUTR: induvidualInfo?.individualUTR,
                niNumber: induvidualInfo?.niNumber,
                isActive: 'Active',
                isDelete: 'Inactive',
            }

            setSelectedDate(induvidualInfo?.dateOfBirth)
            form.setFieldsValue(newValues)
        }
    }, [induvidualInfo])
    const onPartnerEditData = (): void => {
        void onSaveData()
    }

    const onSaveData = async (): Promise<void> => {
        try {
            await form.validateFields()
            setButtonLoading(true)
            const formdata = form.getFieldsValue()
            const dataToSave = {
                partnerId: 0,
                partnershipId,
                individualId: formdata.individualId ?? 0,
                tagIndividualId: 0,
                individualClientNumber: '',
                title: formdata.title ?? '',
                firstName: formdata.firstName,
                middleName: formdata.middleName ?? '',
                surName: formdata.surName,
                dateOfBirth:
                    moment(formdata.dateOfBirth).format('DD/MM/YYYY') ===
                    'Invalid date'
                        ? ''
                        : moment(formdata.dateOfBirth).format('DD/MM/YYYY'),
                partnerAddressOne: formdata.partnerAddressOne,
                partnerAddressTwo: formdata.partnerAddressTwo ?? '',
                partnerTown: formdata.partnerTown,
                partnerCountry: formdata.partnerCountry ?? '',
                partnerPostCode: formdata.partnerPostCode,
                mobileNumber: formdata.mobileNumber,
                homeNumber: formdata.homeNumber ?? '',
                workNumber: formdata.workNumber ?? '',
                emailAddress: formdata.emailAddress,
                alternativeEmailAddress: formdata.alternativeEmailAddress ?? '',
                individualUTR: formdata.individualUTR ?? '',
                niNumber: formdata.niNumber ?? '',
                isActive: 'Active',
                isDelete: 'Inactive',
            }

            await SavePartner(dispatch, dataToSave).then((reult) => {
                if (reult !== null && reult !== undefined) {
                    form.resetFields()
                    setSelectedDate('')
                    void getClientCompanyDetails(dispatch, 4, partnershipId, 8)
                    setButtonLoading(false)
                    GetPartneshipContactInformation(dispatch, partnershipId)
                    handleSave()
                    window.scroll(0, 0)
                }
            })
        } catch (error) {}
    }

    const customizeRequiredMark = (
        label: React.ReactNode,
        { required }: { required: boolean }
    ): React.ReactElement => (
        <>
            {label}
            &nbsp;
            {required && <span className={commonStyles.requireIcon}>*</span>}
        </>
    )
    const handleNumberChange = (
        e: React.ChangeEvent<HTMLInputElement>,
        fieldName: string
    ): void => {
        const value = e.target.value.replace(/[^0-9]/g, '')
        form.setFieldValue(fieldName, value)
    }

    return (
        <div className={commonStyles.formWrapper}>
            <Form
                name="ct-form"
                initialValues={{ remember: true }}
                autoComplete="off"
                form={form}
                layout="vertical"
                requiredMark={customizeRequiredMark}
            >
                <Row gutter={24}>
                    <Col span={12}>
                        <Form.Item label="Same as Business">
                            <Switch
                                id="2"
                                checked={switchStates[2]}
                                onChange={() => {
                                    handleSwitchChange(2)
                                }}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Same as Correspondence">
                            <Switch
                                id="3"
                                checked={switchStates[3]}
                                onChange={() => {
                                    handleSwitchChange(3)
                                }}
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label="Individual Member"
                            name="individualId"
                        >
                            <Select
                                allowClear
                                placeholder="Please select"
                                onChange={handleIndividualChange}
                                options={[...InduvidualMemberList].sort(
                                    (a, b) => a.label.localeCompare(b.label)
                                )}
                                showSearch
                                filterOption={(input, option) =>
                                    option?.label
                                        ?.toLowerCase()
                                        .includes(input.toLowerCase()) ?? false
                                }
                            />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Date of Birth"
                            name="dateOfBirth"
                            rules={[
                                {
                                    validator: async (_, value) =>
                                        await validateDate(value),
                                },
                            ]}
                        >
                            <Space direction="vertical" size={12}>
                                <DatePicker
                                    allowClear
                                    onChange={onChange}
                                    value={
                                        selectedDate.length > 0
                                            ? dayjs(selectedDate)
                                            : null
                                    }
                                    format="DD/MM/YYYY"
                                    className={commonStyles.dateWidth}
                                    disabledDate={(current) =>
                                        current !== null &&
                                        current > dayjs().endOf('day')
                                    }
                                />
                            </Space>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label="Title"
                            name="title"
                            initialValue={'UNKNOWN'}
                        >
                            <Select
                                allowClear
                                placeholder="Please select"
                                onChange={() => {}}
                                filterOption={(input, option) =>
                                    typeof option?.children === 'string' &&
                                    (option.children as string)
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                }
                                showSearch
                            >
                                <Select.Option value="UNKNOWN">
                                    Unknown
                                </Select.Option>
                                <Select.Option value="MR.">MR.</Select.Option>
                                <Select.Option value="MISS.">
                                    MISS.
                                </Select.Option>
                                <Select.Option value="MRS.">MRS.</Select.Option>
                                <Select.Option value="MS.">MS.</Select.Option>
                                <Select.Option value="DR.">DR.</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Mobile Number"
                            name="mobileNumber"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your mobile number!',
                                },
                                {
                                    pattern: /^\d{10,15}$/,
                                    message:
                                        'Mobile Number must be 10-15 digits!',
                                },
                            ]}
                        >
                            <Input
                                allowClear
                                onChange={(e) => {
                                    handleNumberChange(e, 'mobileNumber')
                                }}
                                inputMode="numeric"
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label="First Name "
                            name="firstName"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your First Name!',
                                },

                                {
                                    validator: async (rule, value) =>
                                        await validateName(
                                            rule,
                                            value,
                                            'First Name'
                                        ),
                                },
                            ]}
                        >
                            <Input allowClear maxLength={100} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Home Number"
                            name="homeNumber"
                            rules={[
                                {
                                    pattern: /^\d{10,15}$/,
                                    message:
                                        'Home Number must be 10-15 digits!',
                                },
                            ]}
                        >
                            <Input
                                allowClear
                                type="tel"
                                inputMode="numeric"
                                onChange={(e) => {
                                    handleNumberChange(e, 'homeNumber')
                                }}
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label="Middle Name"
                            name="middleName"
                            rules={[
                                {
                                    validator: async (rule, value) =>
                                        await validateName(
                                            rule,
                                            value,
                                            'Middle Name'
                                        ),
                                },
                            ]}
                        >
                            <Input allowClear maxLength={100} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Work Number"
                            name="workNumber"
                            rules={[
                                {
                                    pattern: /^\d{10,15}$/,
                                    message:
                                        'Work Number must be 10-15 digits!',
                                },
                            ]}
                        >
                            <Input
                                allowClear
                                inputMode="numeric"
                                onChange={(e) => {
                                    handleNumberChange(e, 'workNumber')
                                }}
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={[16, 48]}>
                    <Col span={12}>
                        <Form.Item
                            label="Surname"
                            name="surName"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your Surname!',
                                },
                                {
                                    validator: async (rule, value) =>
                                        await validateName(
                                            rule,
                                            value,
                                            'Surname'
                                        ),
                                },
                            ]}
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                        >
                            <Input allowClear maxLength={100} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Email"
                            name="emailAddress"
                            rules={[
                                {
                                    type: 'email',
                                    required: true,
                                    message: 'The input is not a valid Email!',
                                },
                            ]}
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                        >
                            <Input allowClear />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={[16, 48]}>
                    <Col span={12}>
                        <Form.Item
                            label="Address 1"
                            name="partnerAddressOne"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please Enter Address 1',
                                },
                            ]}
                        >
                            <Input allowClear maxLength={100} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Alternative Email Address"
                            name="alternativeEmailAddress"
                            rules={[
                                {
                                    type: 'email',
                                    message: 'The input is not a valid Email!',
                                },
                            ]}
                        >
                            <Input allowClear maxLength={100} />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label="Address 2" name="partnerAddressTwo">
                            <Input allowClear maxLength={100} />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        {/* <Form.Item label="NI Number" name="niNumber">
                            <Input allowClear maxLength={9} />
                        </Form.Item> */}
                        <InputFieldNINumber name="niNumber" form={form} />
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label="Town"
                            name="partnerTown"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your Town!',
                                },
                            ]}
                        >
                            <Input allowClear maxLength={50} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Individual UTR" name="individualUTR">
                            <Input allowClear />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label="Country" name="partnerCountry">
                            <Select
                                allowClear
                                placeholder="Please select"
                                onChange={() => {}}
                                options={countryList?.map((country) => ({
                                    value: country.label,
                                    label: country.label,
                                }))}
                                showSearch
                                filterOption={(input, option) =>
                                    option?.label
                                        ?.toLowerCase()
                                        .includes(input.toLowerCase()) ?? false
                                }
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <PostCodeInput
                            name="partnerPostCode"
                            label="Post Code"
                            reuireMessage="Please Enter Post Code"
                            placeHolder={''}
                            setAddressDetails={setAddress}
                        />
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col offset={21} span={2}>
                        <Tooltip title="Save Partner">
                            <Button
                                type="primary"
                                onClick={onPartnerEditData}
                                loading={buttonLoading}
                            >
                                <SaveOutlined />
                            </Button>
                        </Tooltip>
                    </Col>
                </Row>
            </Form>
        </div>
    )
}
const mapStateToProps = (state: any): PartnersDataInterface => {
    return {
        countryList: state.common.countryList,
        partnershipTaps: state.client.partnershipTaps,
        InduvidualMemberList: state.common.InduvidualMemberList,
    }
}
export default connect(mapStateToProps)(Partners)
